// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"error-message_errorMessage__bkp1K","errorMessageTitle":"error-message_errorMessageTitle__U4PGU","errorMessageText":"error-message_errorMessageText__oNunt"};